<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Orders</span>
      </div>
      <div class="card-body">
        <b-tabs content-class="mt-3">
          <b-tab title="Assigned For Packing" active>
            <div class="col-sm-12 text-center" v-if="AllOrders.loading">
              <sweetalert-icon icon="loading" />
            </div>
            <div class="table-responsive card-body">
              <table
                class="table table-bordered"
                id="productsDatatable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Amount</th>
                    <th>Payment</th>
                    <th>Packing</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in AllOrders.data" :key="index">
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.createdAt"
                        visible
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-success"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-success"
                        @click="
                          ChanceStatus(
                            'packed',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Packed <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab title="Ready for packing">
            <div class="col-sm-12 text-center" v-if="AllOrders.loading">
              <sweetalert-icon icon="loading" />
            </div>
            <div class="table-responsive card-body">
              <table
                class="table table-bordered"
                id="productsDatatables"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Amount</th>
                    <th>Payment</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in AllOrders.ready" :key="index">
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.createdAt"
                        visible
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <!-- 
                      <span class="badge badge-danger" v-if="order.products.status[0].type === '0'">pending</span>
                      <span class="badge badge-warning" v-else>unknown</span> -->

                      <button
                        class="btn btn-primary"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-primary"
                        @click="
                          ChanceStatus(
                            'packing',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Packing <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab title="All Orders">
            <div class="col-sm-12 text-center" v-if="AllOrders.loading">
              <sweetalert-icon icon="loading" />
            </div>
            <div class="table-responsive card-body">
              <table
                class="table table-bordered"
                id="productsDatatabless"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Amount</th>
                    <th>Payment</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in AllOrders.allData" :key="index">
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.createdAt"
                        visible
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.products.status[0].type === '0'"
                        >pending</span
                      >
                      <span
                        class="badge badge-warning"
                        v-else-if="
                          order.products.status[0].type === '1' &&
                            order.products.packer === true &&
                            order.products.packStatus === false
                        "
                      >
                        Assigned for packing
                      </span>
                      <span
                        class="badge badge-primary"
                        v-else-if="
                          order.products.status[0].type === '1' &&
                            order.products.packer === true &&
                            order.products.packStatus === true
                        "
                      >
                        Packed
                      </span>
                      <span
                        class="badge badge-primary"
                        v-else-if="
                          order.products.status[0].type === '2' &&
                            order.order.delivery === true &&
                            order.order.deliveryStatus === false
                        "
                      >
                        Assigned for Delivery
                      </span>
                      <span
                        class="badge badge-primary"
                        v-else-if="
                          order.products.status[0].type === '2' &&
                            order.order.delivery === true &&
                            order.order.deliveryStatus === true
                        "
                      >
                        Assigned for Delivery
                      </span>
                      <span
                        class="badge badge-default"
                        v-if="order.products.status[0].type === '3'"
                        >Delivered</span
                      >

                      <!-- <button class="btn btn-success" v-if="order.order.orderId === loadingStatus">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-success"
                        @click="ChanceStatus('packing', order.order.orderId, order.venderId)"
                        v-else
                      >
                        Packed <i class="fa fa-check"></i>
                      </button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loadingStatus: null,
      stopMultipltUpdates: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      AllOrders: "getOrders"
    }),
    ...mapActions({
      getOrders: "getVendorOrders"
    })
  },
  watch: {
    user() {
      if (this.user) {
        this.startDispatchingAction();
      }
    },
    AllOrders() {
      if (this.AllOrders.data) {
        setTimeout(() => {
          if (!this.stopMultipltUpdates) {
            this.dataTablesInit();
          }
          this.stopMultipltUpdates = true;
        }, 2000);
      }
    }
  },
  methods: {
    dataTablesInit() {
      this.productsDatatable = $("#productsDatatable").DataTable({
        lengthMenu: [10, 25]
      });
      this.productsDatatable = $("#productsDatatables").DataTable({
        lengthMenu: [10, 25]
      });
      this.productsDatatable = $("#productsDatatabless").DataTable({
        lengthMenu: [10, 25]
      });
    },
    startDispatchingAction() {
      this.getOrders;
    },
    ChanceStatus(type, orderId, venderId) {
      if (type == "packing") {
        this.loadingStatus = orderId;

        dbFs
          .collection("order")
          .doc(orderId)
          .collection("vendor")
          .doc(venderId)
          .update({
            packStatus: false,
            packer: true,
            status: [
              {
                createdAt: Math.round(+new Date() / 1000),
                type: "1",
                updatedBy: this.user.uid
              }
            ]
          })
          .then(() => {
            this.$root.toast("Orders Packed successfully");
            this.loadingStatus = null;
            this.getOrders;
            $("#productsDatatable")
              .DataTable()
              .destroy();
            $("#productsDatatables")
              .DataTable()
              .destroy();
            $("#productsDatatabless")
              .DataTable()
              .destroy();

            this.stopMultipltUpdates = false;
          })
          .catch(error => {
            this.$root.toast("Oops something went wrong");
            console.log(error);
            this.loadingStatus = null;
          });
      }
      if (type === "packed") {
        this.loadingStatus = orderId;

        dbFs
          .collection("order")
          .doc(orderId)
          .collection("vendor")
          .doc(venderId)
          .update({
            packStatus: true,
            packer: true,
            status: [
              {
                createdAt: Math.round(+new Date() / 1000),
                type: "1",
                updatedBy: this.user.uid
              }
            ]
          })
          .then(() => {
            this.$root.toast("Orders Packed successfully");
            this.loadingStatus = null;
            this.getOrders;
            $("#productsDatatable")
              .DataTable()
              .destroy();
            $("#productsDatatables")
              .DataTable()
              .destroy();
            $("#productsDatatabless")
              .DataTable()
              .destroy();

            this.stopMultipltUpdates = false;
          })
          .catch(error => {
            this.$root.toast("Oops something went wrong");
            console.log(error);
            this.loadingStatus = null;
          });
      }
    }
  }
};
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
